import { render } from "./MLPassagesPanel.vue?vue&type=template&id=f956aca2&scoped=true&ts=true"
import script from "./MLPassagesPanel.vue?vue&type=script&lang=ts"
export * from "./MLPassagesPanel.vue?vue&type=script&lang=ts"

import "./MLPassagesPanel.vue?vue&type=style&index=0&id=f956aca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f956aca2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSlider,QBtn,QSpinnerDots,QLinearProgress,QMenu,QList,QItem,QItemSection,QBadge,QSpinner,QTooltip});qInstall(script, 'directives', {ClosePopup});
